var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4C4C4C",
    d: "M8.214 0c.276 0 .5.192.5.429v.74C9.446 1.303 10 1.944 10 2.714V8.43C10 9.296 9.296 10 8.429 10H1.57C.704 10 0 9.296 0 8.429V2.714c0-.82.628-1.492 1.428-1.565V.43c0-.237.224-.429.5-.429.277 0 .5.192.5.429v.713h2.143V.429c0-.21.177-.386.41-.422L5.072 0c.277 0 .5.192.5.429v.713h2.143V.429c0-.21.177-.386.41-.422zm.928 4.714H.857v3.715c0 .394.32.714.714.714H8.43c.394 0 .714-.32.714-.714l-.001-3.715zM8.429 2H1.57c-.394 0-.714.32-.714.714v1h8.285v-1C9.143 2.32 8.824 2 8.43 2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.d95c51040b0aec03c8bbac468a65212c.svg";
export { ForwardRef as ReactComponent };